<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="12" md="6" lg="auto">
        <v-btn-toggle dense class="rounded-small" v-model="toggle_exclusive">
          <v-btn class="px-7"> Resumido </v-btn>

          <v-btn class="px-7"> Ampliada </v-btn>
        </v-btn-toggle>
      </v-col>

      <v-col cols="8" md="6" lg="2">
        <!-- <v-row>
          <v-switch
            v-model="QueueSearch"
            inset
            @change="requestDashboard"
          ></v-switch> -->

        <v-autocomplete
          :disabled="isLoading"
          :items="filteredQueueListToPicker"
          v-model="queueFilter"
          name="Cola"
          item-text="queue"
          item-value="queue"
          filled
          rounded
          single-line
          dense
          class="rounded-small"
          hide-details
          clearable
          multiple
        ></v-autocomplete>
        <!-- </v-row> -->
      </v-col>
    </v-row>

    <v-row v-if="toggle_exclusive == 0">
      <v-col cols="12">
        <v-card outlined>
          <br />
          <v-data-table
            :headers="headers"
            :items="filteredNewQueueList"
            item-key="queue"
            :items-per-page="15"
            :item-class="getRowClass"
          >
            <template v-slot:[`item.queue`]="{ item }">
              <v-list dark color="transparent" dense class="py-0">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ item.queue }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ queueName(item.queue) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <template v-if="toggle_exclusive == 1">
      <v-data-iterator :items="filteredNewQueueList" :items-per-page="-1" hide-default-footer>
        <template v-slot:default="props">
          <v-row>
            <v-col cols="12" md="6" lg="4" xl="3" v-for="item in props.items" :key="item.queue">
              <v-hover v-slot="{ hover }">
                <v-card
                  outlined
                  :class="hover ? 'shadow-2' : 'shadow-5'"
                  style="transition: 0.2s"
                  @click="detail(item)"
                >
                  <v-toolbar flat tile color="transparent" class="border-toolbart">
                    <v-list color="transparent" dense class="pb-0">
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">
                            {{ item.queue }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ queueName(item.queue) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>

                    <v-spacer></v-spacer>

                    <span class="caption pr-3">
                      {{ item.agents }}
                      {{ item.agents == 1 ? " agente" : " agentes" }}
                    </span>
                  </v-toolbar>
                  <v-card-text class="pt-0">
                    <v-row dense justify="center" align-content="center" align="center">
                      <v-col cols="auto" md="4">
                        <v-progress-circular
                          :rotate="360"
                          :size="105"
                          :width="15"
                          :value="item.servicelevel"
                          color="success"
                        >
                          {{ item.servicelevel }}
                        </v-progress-circular>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-list dense class="transparent">
                          <v-list-item>
                            <v-list-item-title> En llamada </v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                              {{ item.talking }}
                            </v-list-item-subtitle>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-title>
                              No disponible
                            </v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                              {{ item.unavailable }}
                            </v-list-item-subtitle>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-title> Libre </v-list-item-title>

                            <v-list-item-subtitle class="text-right">
                              {{ item.free }}
                            </v-list-item-subtitle>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-card-actions :class="item.waiting != 0 ? 'secondary py-5' : 'blue-grey darken-2 py-5'">
                    <v-row class="white--text" align="center" justify="center">
                      <v-icon small dark class="mr-1"> mdi-phone-ring </v-icon>
                      <span>{{ item.waiting }}</span>

                      <span class="mx-3">·</span>

                      <v-icon small dark class="mr-1">
                        mdi-phone-remove
                      </v-icon>
                      <span class="subheading">{{ item.abandon }}</span>

                      <span class="mx-3">·</span>

                      <v-icon small dark class="mr-1"> mdi-phone-check </v-icon>
                      <span>{{ item.answered }}</span>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </template>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import { QUEUE_STATUS_EP } from "./utils";

export default {
  props: {
    presetAxiosClient: {
      type: Function,
    },
    presetEndpoints: {
      type: Object,
    },
  },
  data() {
    return {
      axiosClient: PbxHttpClient,
      endpoints: QUEUE_STATUS_EP,
      toggle_exclusive: 0,
      queueFilter: [],
      // extensionItems: {},
      newQueueList: [],
      array_queue: [],
      interval: "",
      queueItems: [],
      headers: [
        { text: "Cola", value: "queue", width: "" },

        { text: "N. Agentes", value: "agents", width: "" },

        { text: "Abandonadas", value: "abandon", width: "" },

        { text: "Contestadas", value: "answered", width: "" },

        { text: "% de atención", value: "servicelevel", width: "" },

        { text: "En llamada", value: "talking", width: "" },

        { text: "No disponible", value: "unavailable", width: "" },

        { text: "Libre", value: "free", width: "" },

        { text: "En espera", value: "waiting", width: "" },
      ],
    };
  },

  computed: {
    CurrentRole() {
      return this.$store.getters["passport/GET_ROLE"];
    },
    UserQueues() {
      return this.$store.getters["queue/GET_QUEUES"];
    },
    filteredQueueListToPicker() {
      return this.CurrentRole === 10
        ? this.newQueueList.filter((el) =>
            this.CurrentRole === 10 ? this.UserQueues.some((usrQueue) => +usrQueue.number === +el.queue) : el,
          )
        : this.newQueueList;
    },
    filteredNewQueueList() {
      // if (this.CurrentRole === 10)
      // return this.queueFilter.filter((el) => this.UserQueues.some((usrQueue) => +usrQueue.number === +el.queue));
      return this.queueFilter.length
        ? this.newQueueList
            .filter((el) => this.queueFilter.includes(el.queue))
            .filter((el) =>
              this.CurrentRole === 10 ? this.UserQueues.some((usrQueue) => +usrQueue.number === +el.queue) : el,
            )
        : this.newQueueList.filter((el) =>
            this.CurrentRole === 10 ? this.UserQueues.some((usrQueue) => +usrQueue.number === +el.queue) : el,
          );
      //     if (!this.queueFilter) return this.newQueueList;
      //     return this.items.filter((item) => item.gender === this.selectedItem);
    },
  },

  mounted() {
    // this.statusQueue();
    if (this.presetAxiosClient) this.axiosClient = this.presetAxiosClient;
    if (this.presetEndpoints) this.endpoints = this.presetEndpoints;
    this.toggle_exclusive = this.$route?.query?.tab || 0;
    this.getQueues();
    this.getNewQueueList();
    this.$store.dispatch("queue/GET_QUEUES", this.CurrentRole === 10);

    this.interval = setInterval(() => {
      this.getNewQueueList();
    }, 6000);
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  methods: {
    getRowClass(item) {
      return item.waiting != 0 ? "secondary white--text" : "blue-grey darken-2 white--text";
    },

    queueName(queue) {
      const result = this.queueItems.filter((item) => item.number == queue);

      return result[0] ? (result[0].name ? result[0].name : "-") : "-";
    },

    async getNewQueueList() {
      try {
        const { data } = await this.axiosClient.get(this.endpoints.getNewList);
        this.newQueueList = data.data;
      } catch (err) {
        if (err.response.data?.error === "Invalid token" && this.presetAxiosClient) {
          this.$router.push("/");
        } else {
          this.$snotify.error("Hubo un error consultandolas extensiones.", "¡Error!");
        }
      }
    },

    async getQueues() {
      this.axiosClient
        .get(this.endpoints.getQueues)
        .then((res) => {
          this.queueItems = res.data.data;
        })
        .catch((err) => {
          // console.error(error);
          if (err.response.data?.error === "Invalid token" && this.presetAxiosClient) {
            this.$router.push("/");
          } else {
            this.$snotify.error("No se pudo obtener listado de colas.", "¡Error!");
          }
        })
        .finally(() => {
          this.isLoadingQueueItems = false;
        });
    },

    async detail(value) {
      try {
        const request = {
          extension: value.queue,
        };

        this.$store.commit("queue/STATUS_QUEUE", request);
        this.$router.push({
          path: "DetailStatusColas",
        });
      } catch (error) {
        console.error("error getting details", error);
      }
    },
  },
};
</script>

<style scoped>
.border-toolbart {
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
}
</style>
